import ResetPassword from '@shared/components/auth/ResetPassword';
import * as Actions from '@/app/store/actions';
import * as authActions from '@/app/auth/store/actions';
import { useDispatch } from 'react-redux';
import { resetPassword } from '../../../../services/resetPassword/resetPassword';
import { useState, useEffect } from 'react';
import JwtService from '@/app/services/jwtService';
import { useNavigate, useLocation } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';

const ProductOwnerResetPasswordPage = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	// Username arrives as a query param: the redirect into this page runs through window.location.href
	// (see user.actions.js), which drops router state, so state.username would always be undefined.
	const [username] = useState(new URLSearchParams(location?.search).get('username') || '');

	useEffect(() => {
		if (!username) {
			navigate('/forgot-password');
		}
	}, [dispatch, username]);

	const handleSuccess = (message) => {
		// Clear the still-valid unverified session so a hard reload after reset can't re-enter the
		// first-login redirect (mirrors the admin app's reset-success cleanup).
		JwtService.setSession(null);
		secureLocalStorage.removeItem('needs_password_reset');
		dispatch(authActions.removeUserData());
		dispatch(
			Actions.showMessage({
				message: `${message}. Redirecting...`,
				variant: 'success',
				autoHideDuration: 3000,
			})
		);
	};

	const handleError = (message) => {
		dispatch(
			Actions.showMessage({
				message,
				variant: 'error',
				autoHideDuration: 3000,
			})
		);
	};

	const handleResetPassword = async (data) => {
		return resetPassword({
			...data,
			role: 'product_owner',
			username,
		});
	};

	return (
		<div className="min-h-screen flex items-center justify-center p-4 bg-[url('/assets/images/banner/bg.png')] bg-no-repeat bg-center bg-cover">
			<ResetPassword onError={handleError} onResetPassword={handleResetPassword} onSuccess={handleSuccess} />
		</div>
	);
};

export default ProductOwnerResetPasswordPage;
